// Transient UI state — open dialogs, command palette, drawer.

import { create } from "zustand";

interface UiState {
  navExpanded: boolean;
  commandOpen: boolean;
  notificationsOpen: boolean;
  drawer: null | { kind: string; payload?: unknown };
  toasts: Array<{ id: string; message: string; tone?: "ok" | "warn" | "error" | "info" }>;
  toggleNav: () => void;
  setCommandOpen: (v: boolean) => void;
  setNotificationsOpen: (v: boolean) => void;
  openDrawer: (kind: string, payload?: unknown) => void;
  closeDrawer: () => void;
  toast: (message: string, tone?: "ok" | "warn" | "error" | "info") => void;
  dismissToast: (id: string) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  navExpanded: false,
  commandOpen: false,
  notificationsOpen: false,
  drawer: null,
  toasts: [],
  toggleNav: () => set({ navExpanded: !get().navExpanded }),
  setCommandOpen: (commandOpen) => set({ commandOpen }),
  setNotificationsOpen: (notificationsOpen) => set({ notificationsOpen }),
  openDrawer: (kind, payload) => set({ drawer: { kind, payload } }),
  closeDrawer: () => set({ drawer: null }),
  toast: (message, tone = "info") => {
    const id = Math.random().toString(36).slice(2, 8);
    set({ toasts: [...get().toasts, { id, message, tone }] });
    setTimeout(() => get().dismissToast(id), 4500);
  },
  dismissToast: (id) => set({ toasts: get().toasts.filter(t => t.id !== id) }),
}));
